var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{attrs:{"color":"info","title":"Mein Unterricht"}},[_c('template',{slot:"extension"},[_c('v-tabs',{attrs:{"background-color":"info darken-1","align-with-title":!_vm.$vuetify.breakpoint.xs,"rounded":""}},[(_vm.registerVisible)?_c('v-tab',{attrs:{"to":{
          name: 'MyRegister',
          props: { person: _vm.person, view: 'list' },
        }}},[_vm._v("Unterricht")]):_vm._e(),(_vm.examsVisible)?_c('v-tab',{attrs:{"to":{ name: 'MyExams' }}},[_vm._v("Probenplan")]):_vm._e()],1)],1),_c('router-view',{attrs:{"person":_vm.person}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }